import { utils } from '@easygenerator/fragment-sdk';

export type ConfigOptions = {
  [key: string]: string;
};

export default class Config {
  static getInstance() {
    if (!Config.instance) {
      Config.instance = new Config();
    }
    return Config.instance;
  }

  private static instance: Config;

  private config!: ConfigOptions;

  get learnServiceUrl() {
    return this.config.learnServiceUrl;
  }

  get discoveryServiceUrl() {
    return this.config.discoveryServiceUrl;
  }

  public async initialize() {
    const config = await utils.HttpWrapper.get(`${window.location.origin}/configz`);
    this.config = config;
  }
}
